
/**************************************************
 * cookie同意バナー
 **************************************************/
const cookieAgreementBanner = (function() {
  const expire = 365; // 有効期限（日）
  const cc = document.querySelector('.cookie-consent');
  const ca = document.querySelector('.cookie-agree');
  const flag = localStorage.getItem('popupFlag');
  if(!cc) return;
  
  if (flag != null) {
    const data = JSON.parse(flag);
    if (data['value'] == 'true') {
      popup();
    } else {
      const current = new Date();
      if (current.getTime() > data['expire']) {
        setWithExpiry('popupFlag', 'true', expire);
        popup();
      }      
    }
  } else {
    setWithExpiry('popupFlag', 'true', expire);
    popup();
  }
  ca.addEventListener('click', () => {
    cc.classList.add('cc-hide1');
    setWithExpiry('popupFlag', 'false', expire);
  });
  
  function setWithExpiry(key, value, expire) {
    const current = new Date();
    expire = current.getTime() + expire * 24 * 3600 * 1000;
    const item = {
      value: value,
      expire: expire
    };
    localStorage.setItem(key, JSON.stringify(item));
  }
  
  function popup() {
    cc.classList.add('is-show');
  }
})();

/**************************************************
 * mouse stalker
 **************************************************/
const mouseStalker = (function() {
  const stalker = document.getElementById('mouse-stalker');
  let hovFlag = false;

  document.addEventListener('mousemove', function (e) {
      stalker.style.transform = 'translate(' + e.clientX + 'px, ' + e.clientY + 'px)';
  });

  const linkElem = document.querySelectorAll('a:not(.no_stick_)');
  for (let i = 0; i < linkElem.length; i++) {
      linkElem[i].addEventListener('mouseover', function (e) {
          hovFlag = true;
          stalker.classList.add('is_active');
      });

      linkElem[i].addEventListener('mouseout', function (e) {
          hovFlag = false;
          stalker.classList.remove('is_active');
      });
  }
})();

/**************************************************
 * Title animation - GSAPライブラリ使用
 **************************************************/
document.addEventListener("DOMContentLoaded", function() {
  const title = document.querySelector(".mv-title__heading");
  const dots = document.querySelector('.mv-bg-dots');
  if(!title || !dots) return;
  
  lettering(title);
  setTimeout(animation, 1000);
  setTimeout(function() {
    dots.classList.add('animate');
  }, 2500);
});

//文章を一文字ずつ分割する
function lettering(element) {
  const text = element.textContent;
  const letters = text.split("");
  const html = letters.map(function(letter) {
    return "<span>" + letter + "</span>";
  }).join("");

  element.innerHTML = html;
}

//アニメーションの設定
function animation() {
  const title1 = new TimelineMax();
  title1.staggerFromTo(".mv-title__heading span", 1.2, 
  {ease: Back.easeOut.config(1.0), opacity: 0, rotate: 10, x: 250, y: 100, bottom: -10, right: 0},
  {ease: Back.easeOut.config(1.0), opacity: 1, rotate: 0, x: 0, y: 0, bottom: 0}, 0.05);
}


/**************************************************
 * Scroll TOP
 **************************************************/
const handleAnchorClick = (function() {
  const anchors = document.querySelectorAll('a[href^="#"]');
  const header = document.querySelector('header').offsetHeight; //header高さ
  const urlHash = location.hash; // URLのアンカー（#以降の部分）を取得

  // 各 anchor にクリックイベント
  for (let i = 0; i < anchors.length; i++) {
    anchors[i].addEventListener('click', (e) => {
      e.preventDefault();  //デフォルトのクリックイベント無効化

      // 各 anchor の href属性取得
      const href = anchors[i].getAttribute("href");

      // topに戻る以外のアンカー
      if (href !== '#top') {
        const target = document.getElementById(href.replace('#', ''));
        const position = window.pageYOffset + target.getBoundingClientRect().top - header;

        window.scroll({
          top: position, // スクロール先要素の左上までスクロール
          behavior: 'smooth'
        });

      } else {
        window.scroll({
          top: 0,  // スクロール先
          behavior: 'smooth' 
        });
      }
    });
  }
})();
  
const handleScroll = (function() {
  const pageTopBtn = document.querySelector('.page-top');
  const scrollBar = document.querySelector('.home__scroll');
  const recruitSection = document.querySelector('.section--recruit');

  //トップへ戻るボタン:一定値を超えたら表示する
  window.addEventListener('scroll', function() {
    if (window.pageYOffset > 100) {
      pageTopBtn.classList.add('active');
    } else {
      pageTopBtn.classList.remove('active');
    }
  });

  //トップへ戻るボタン:フッターを超えたら非表示にする
  window.addEventListener('scroll', function() {
    let height = document.documentElement.scrollHeight;
    let position = window.innerHeight + window.pageYOffset;
    let footer = document.querySelector('footer').offsetHeight;
  
    if (height - position < footer) {
      pageTopBtn.classList.add('absolute');
    } else {
      pageTopBtn.classList.remove('absolute');
    }
  });

  //スクロールバー:リクルートセクションを超えたら消す
  if (recruitSection) {
    window.addEventListener('scroll', function() {
      const position = window.scrollY;
      const recruitPosition = recruitSection.offsetTop;

      if ( position > recruitPosition) {
        scrollBar.classList.remove('active');
      } else {
        scrollBar.classList.add('active');
      }
    });
  }
})();


/** ==================================================
 * scroll animation 
==================================================*/
const animateEl = (function() {
  window.addEventListener("load", () => {

    const readyEl = document.querySelectorAll(".ready");
    window.addEventListener("scroll", animate);

    animate();

    function animate() {
      // 発火位置の設定
      const triggerTop = (window.innerHeight / 3) * 2;//33.33%

      readyEl.forEach((el) => {
        // 要素の頭部分の座標を取得
        const elTop = el.getBoundingClientRect().top;

        // 要素の頭部分が発火位置を超えたら
        if (elTop < triggerTop) {
          el.classList.add("animate");
        }
      });
    }
  });
})();

/**************************************************
 * form file input
 **************************************************/
const formFile = (function() {
  document.addEventListener('DOMContentLoaded', function() {
    const inputFiles = document.querySelectorAll('input.input-file');

    inputFiles.forEach(function(inputFile) {
      inputFile.addEventListener('change', function() {
        let file = this.files[0];
        let selectFile = this.parentNode.querySelector('.file-text');
        if (selectFile) {
          selectFile.textContent = file ? file.name : '選択されていません';
          selectFile.classList.toggle('selected', !!file);
        }
      });
    });
  });
})();

/**************************************************
 * バリデーション（checkbox＆file）
 **************************************************/
const formCheckbox = (function() {
  const checkbox = document.querySelector('.checkbox');
  const fileTextElements = document.querySelectorAll('.file-text');
  const formSubmit = document.querySelector('input[type="submit"]');

  if (!formSubmit) {
    return;
  }

  function isValid() {
    const checkboxValid = checkbox ? checkbox.checked : true;
    const fileValid = Array.from(fileTextElements).every(fileText => {
      const fileParent = fileText.parentElement;
      const hasFile = fileParent.querySelector('.mw-wp-form_file input[type="hidden"]');
      if (hasFile) {
        fileText.style.display = 'none';  // ファイルが存在する場合、"選択されていません"のテキストを非表示にします
        return true;
      } else {
        fileText.style.display = 'block';  // ファイルが存在しない場合、"選択されていません"のテキストを表示します
        return fileText.classList.contains('selected');
      }
    });
    return checkboxValid && fileValid;
  }

  function updateButton() {
    if (isValid()) {
      formSubmit.classList.remove('invalid');
    } else {
      formSubmit.classList.add('invalid');
    }
  }

  updateButton();

  if (checkbox) {
    checkbox.addEventListener('change', updateButton);
  }

  if (fileTextElements) {
    const observer = new MutationObserver(updateButton);
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();


/**************************************************
 * Scroll Lock Function
 **************************************************/
/**
 * モーダル系UIで起こりがちな２つの問題に対処する
 *  1. 裏側がスクロールされる現象
 *  2. 裏側にキーボードフォーカスされる現象
 *
 * ページ下部に使い方を記載
 */

const BODY = document.body;
const CSS_CAN_SCROLL = '.js-canScroll'; // スクロール可能な要素に付与したクラス名

/**
 * Windows判定
 * @returns {Boolean} OSがWindowsであればtrue
 */
function isWindows() {
  return window.navigator.userAgent.toLowerCase().indexOf('windows nt') !== -1;
}


const createInteractiveElArray = (element) => {
  const INTERACTIVE_SELECTOR = 'button, a';
  // モーダル要素内のフォーカス可能な要素を取得する
  const elements = element.querySelectorAll(INTERACTIVE_SELECTOR);
  const interactiveElArray = Array.from(elements);
  return interactiveElArray;
};


const focusToButton = (parentElement, isFirstFocus = true) => {
  if (!parentElement) {
    throw new Error('要素が見つかりませんでした');
  }

  const focusableArray = createInteractiveElArray(parentElement);

  if (focusableArray.length > 0) {
    focusableArray[isFirstFocus ? 0 : focusableArray.length - 1].focus();
  }

  focusableArray[0].focus();
};

const modalFocus = (event, parentElement, onClose) => {
  if (!parentElement) {
    return;
  }

  switch (event.code) {
    case 'Enter':

    case 'Space':
      break;

    case 'Escape':
      onClose();
      break;

    case 'Tab': {
      // モーダル画面内にフォーカスが当たっているか検証
      const interactiveElArray = createInteractiveElArray(parentElement);
      const focusIndex = interactiveElArray.findIndex(el => el === document.activeElement);

      if (interactiveElArray.length === 1) {
        // フォーカス可能な要素が1つしかない場合、その要素のみフォーカス
        event.preventDefault();
        event.stopImmediatePropagation();
        focusToButton(parentElement, true);
        break;
      }

      if (focusIndex === 0) {
        if (event.shiftKey) {
          // モーダル画面以外にフォーカスが当たっていたらイベントを無効化
          event.preventDefault();
          event.stopImmediatePropagation();
          focusToButton(parentElement, false);
        }
      } else if (focusIndex >= interactiveElArray.length - 1) {
        // 最後の要素にふれていたら1番目の要素にフォーカスをあてる
        if (!event.shiftKey) {
          event.preventDefault();
          event.stopImmediatePropagation();
          focusToButton(parentElement, true);
        }
      } else if (focusIndex === -1) {
        // 画面外の要素にフォーカスがあたっていたら1番目の要素にフォーカスをあてる
        focusToButton(parentElement, true);
      }

      break;
    }
  }
};

const isScrollable = (element) => {
  return element.clientHeight < element.scrollHeight;
}

const scrollLock = (event) => {
  const canScrollElement = event.target?.closest(CSS_CAN_SCROLL);

  if (canScrollElement === null) {
    // 対象の要素でなければスクロール禁止
    event.preventDefault();
    return;
  }

  if (canScrollElement && isScrollable(canScrollElement)) {
    // 対象の要素があり、その要素がスクロール可能であればスクロールを許可する
    event.stopPropagation();
  } else {
    // 対象の要素はスクロール禁止
    event.preventDefault();
  }
};


// **************************************************
// ドロップダウン Placeholderスタイル
// **************************************************
document.addEventListener("DOMContentLoaded", function() {
  const selectElements = document.querySelectorAll(".js-select");
  selectElements.forEach(function(select) {
    select.classList.add("is-empty");

    // selectのoptionを切り替え時
    select.addEventListener("change", function() {
      // option選択時
      if (this.value !== "") {
        this.classList.remove("is-empty");
      } 
      else {
        // is-emptyクラスを付与
        this.classList.add("is-empty");
      }
    });
  });
});

// **************************************************
// scrollLockFix.js
// **************************************************
const scrollLockTroubleShooting = (event) => {
  const element = event.target;

  if (element === null) {
    return;
  }

  // 以下の手順で発生するスクロールのバグ対策。回避するため1pxだけスクロール量を減らす
  // 1. メニューを上下どちらかに最大までスクロールする
  // 2. 更にスクロールを行うとページ全体がスクロールする
  if (element.scrollTop + element.clientHeight === element.scrollHeight) {
    element.scrollTop = element.scrollTop - 1;
  }

  if (element.scrollTop === 0) {
    element.scrollTop = 1;
  }
};

// モーダルオープン時のスクロール位置を記録する
let scrollPos = 0;

const scrollLockFixWindows = () => {
  /**
   * windowsのときのbody固定処理
   */
  scrollPos = document.documentElement.scrollTop || document.body.scrollTop;
  BODY.classList.add('_scrollLockWindows');
  BODY.style.top = `-${scrollPos}px`;
}

const scrollLockFixRemoveWindows = () => {
  /**
   * windowsのときのbody固定処理の解除
   */
  BODY.classList.remove('_scrollLockWindows');
  BODY.style.top = 'initial';
  BODY.scrollTop = scrollPos;
  document.documentElement.scrollTop = scrollPos;
}

const scrollLockFix = (element) => {
  if (isWindows()) {
    scrollLockFixWindows();
  } else {
    BODY.classList.add('_scrollLock');
  }
  const canScrollElement = element.querySelector(CSS_CAN_SCROLL);
  if (!canScrollElement) {
    return;
  }

  canScrollElement.addEventListener('scroll', scrollLockTroubleShooting);
};

const scrollLockFixRemove = (element) => {
  if (isWindows()) {
    scrollLockFixRemoveWindows();
  } else {
    BODY.classList.remove('_scrollLock');
  }
  const canScrollElement = element.querySelector(CSS_CAN_SCROLL);

  if (!canScrollElement) {
    return;
  }

  canScrollElement.removeEventListener('scroll', scrollLockTroubleShooting);
};

/**
 * ドロワーメニューの開閉
 * modalControl.jsを使用
 * buttonクリックでドロワーメニューの開閉を切り替える
 * ドロワーメニューが開いている時はbodyをスクロールさせない
 */
{
  const HAMBURGER = document.getElementById('js-hamburgerBtn');
  const NAV = document.getElementById('js-drawerNav');
  const NAV_LINK = document.querySelectorAll('#js-drawerNav a');

  /**
   * ⭐キーボードフォーカスのイベントハンドラ
   */
  const focusHandleMenu = event => {
    modalFocus(event, NAV, close);
  }

  /**
   * open drawer menu
   */
  const openDrawerMenu = () => {
    // モーダル表示状態のクラスを追加する
    HAMBURGER.classList.add('_open');
    NAV.classList.add('_open');

    // ⭐キーボードフォーカスの制御イベントを登録
    window.addEventListener('keydown', focusHandleMenu, { capture: true });

    // ⭐スクロール固定のイベントを登録
    document.addEventListener('touchmove', scrollLock, { passive: false });
    scrollLockFix(NAV);
  }

  /**
   * close drawer menu
   */
  const closeDrawerMenu = () => {
    // モーダル表示状態のクラスを削除する
    HAMBURGER.classList.remove('_open');
    NAV.classList.remove('_open');

    // ⭐キーボードフォーカスの制御を破棄
    window.removeEventListener('keydown', focusHandleMenu, { capture: true });

    // ⭐スクロール固定のイベントを破棄
    document.removeEventListener('touchmove', scrollLock);
    scrollLockFixRemove(NAV);

    // ⭐フォーカス位置を戻す
    HAMBURGER.focus();
  }

  /**
   * ドロワーメニューが開いているか判定
   * @returns {Boolean} ドロワーメニューが開いていればtrue
   */
  const isDrawerOpen = () => {
    return HAMBURGER.classList.contains('_open');
  }

  /**
   * ドロワーメニューの開閉状態によって処理を分ける
   * ドロワーメニューが閉じていれば開くし開いていれば閉じる
   */
  const drawerOperation = () => {
    if (isDrawerOpen()) {
      closeDrawerMenu();
    } else {
      openDrawerMenu();
    }
  }

  // ハンバーガーボタンのクリックイベントを登録
  HAMBURGER.addEventListener('click', drawerOperation, false);

  // ドロワーメニュー内の<a>にクリックイベントを登録
  // ドロワーメニューオープン時にドロワーメニュー内の<a>がクリックされたらドロワーメニューを閉じる
  NAV_LINK.forEach((element) => {
    element.addEventListener('click', () => {
      closeDrawerMenu();
    })
  });
}

/**************************************************
 * news category
 **************************************************/
(function(){

  const newsCategorySwitch = (function () {
    const card = document.querySelectorAll(".news-item");
    const filterTab = document.querySelectorAll(".filter__item");
    if(!card) return;

    function clickFunc(e) {
      let id = e.currentTarget.dataset.item;
      console.log('id', id);
      if (id == 1) {
        card.forEach((newsItem) => {
          newsItem.classList.add('_show');
        });
        filterTab.forEach((e) => {
          e.classList.remove('_active');
        })
        e.currentTarget.classList.add('_active');
        return;
      }

      let targetItem = document.querySelector(
        `.news-item[data-item="${id}"]`
        );

      card.forEach((newsItem) => {
        newsItem.classList.add('_hide');
        newsItem.classList.remove('_show');
      })

      if(targetItem.classList.contains('_hide')) {
        targetItem.classList.remove('_hide');
        targetItem.classList.add('_show');
      }

      filterTab.forEach((tab) => {
        tab.classList.remove('_active');
      });
    
      e.currentTarget.classList.add('_active');
    }

    filterTab.forEach((tab) => {
      tab.addEventListener('click', clickFunc);
    });

  })();

})();


// **************************************************
// シェアURL挿入
// **************************************************
const snsShare = (() => {
	const urlSet = (link, url) => {
		const links = document.querySelectorAll(link);
    if (!links) return;

		links.forEach((e) => {
			const resultUrl = url + (location.href);
			e.href = resultUrl;
		});
	}
	urlSet(
		'.js-share-twitter',
		'http://twitter.com/share?url='
	);
	urlSet(
		'.js-share-facebook',
		'https://www.facebook.com/share.php?u='
	);
	urlSet(
		'.js-share-line',
		'https://social-plugins.line.me/lineit/share?url='
	);
})();